import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  BiUserCircle,
  BiLogOut,
  BiWallet,
  BiCog,
  BiInfoCircle,
  BiBarChartAlt2,
  BiGroup,
  BiDiamond,
  BiShareAlt,
  BiBookContent,
  BiCheckShield,
} from "react-icons/bi";
import { MdSportsCricket } from "react-icons/md";
import "./Dashboard.scss";
import ActiveMatch from "../../common/ActiveMatch/ActiveMatch";
import { useDashboardQuery } from "../../../store/service/userlistService";
import LadgerDetails from "../ladgerdetail/LadgerDetails";
import CashTransanction from "../CashTransanction/CashTransanction";
import SettingModals from "./SettingModals";
import MasterDetails from "../masterDetail/MasterDetails";
import SportModal from "./SportModal";
import { useGetLiveCasinoListQuery } from "../../../store/service/CasinoServices";
import { effectiveUserType, roleLabel } from "../../../utils/roles";
import AdminDashboardTop from "./AdminDashboardTop";

const resolveCasinoImage = (name = "", index = 0) => {
  const n = String(name).toLowerCase();
  if (n.includes("worli") && n.includes("matka")) return "/Images/casino/worli-matka.jpg";
  if (n.includes("matka")) return "/Images/casino/matka.jpg";
  if (n.includes("teenpatti") || n.includes("teen patti") || n.includes("tp")) {
    return "/Images/casino/teen-patti-1-day-sky.jpg";
  }
  if (n.includes("dragon")) {
    return n.includes("2") || n.includes("two")
      ? "/Images/casino/dragon-tiger2.jpg"
      : "/Images/casino/dragon-tiger-sky.jpg";
  }
  if (n.includes("lucky") && (n.includes("7") || n.includes("seven"))) {
    return "/Images/casino/lucky-7-casino-skyx99.jpg";
  }
  if (n.includes("aaa")) return "/Images/casino/aaa.jpg";
  let hash = 0;
  for (let i = 0; i < n.length; i += 1) hash = (hash * 31 + n.charCodeAt(i)) >>> 0;
  return `/Images/casino/${((hash || index) % 13) + 1}.jpg`;
};

const DashTile = ({ icon, label, onClick, tone = "action" }) => (
  <button type="button" className={`dash-tile dash-tile--${tone}`} onClick={onClick}>
    <span className="dash-tile__icon" aria-hidden="true">
      {icon}
    </span>
    <span className="dash-tile__text">
      <span className="dash-tile__label">{label}</span>
    </span>
  </button>
);

const DashStat = ({ icon, title, desc, onClick }) => (
  <button
    type="button"
    className={`dash-stat${onClick ? " is-clickable" : ""}`}
    onClick={onClick}
    disabled={!onClick}>
    <span className="dash-stat__icon" aria-hidden="true">
      {icon}
    </span>
    <span className="dash-stat__body">
      <strong>{title}</strong>
      {desc ? <small>{desc}</small> : null}
    </span>
  </button>
);

const Dashboard = () => {
  const [openModal, setOpenModals] = useState(false);
  const [openSetting, setSetting] = useState(false);
  const [openDashBoard, setOpenDashBoard] = useState(false);
  const [openModalReport, setOpenModalsReport] = useState(false);
  const [openSportModals, setSportModals] = useState(false);
  const nav = useNavigate();
  const { data: dataDes } = useDashboardQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const { data: casinoList } = useGetLiveCasinoListQuery();
  const uType = effectiveUserType();
  const userId = localStorage.getItem("userId") || "";
  const isSuper = uType === "7";

  const actionTiles = useMemo(
    () => [
      {
        key: "details",
        icon: <BiUserCircle />,
        label: isSuper ? "SuperAdmin" : roleLabel(uType),
        onClick: () => setOpenDashBoard(true),
      },
      {
        key: "sports",
        icon: <MdSportsCricket />,
        label: "Sports",
        onClick: () => setSportModals(true),
      },
      ...(isSuper
        ? [
            {
              key: "settlement",
              icon: <BiCheckShield />,
              label: "Bet Settle",
              onClick: () => nav("/bet-settlement"),
            },
          ]
        : []),
      {
        key: "ledger",
        icon: <BiBookContent />,
        label: "Ledger",
        onClick: () => setOpenModals(true),
      },
      {
        key: "cash",
        icon: <BiWallet />,
        label: "Cash Txn",
        onClick: () => setOpenModalsReport(true),
      },
      {
        key: "setting",
        icon: <BiCog />,
        label: "Settings",
        onClick: () => setSetting(true),
      },
      {
        key: "logout",
        icon: <BiLogOut />,
        label: "Logout",
        onClick: () => {
          localStorage.clear();
          nav("/");
        },
      },
    ],
    [uType, isSuper, nav]
  );

  const stats = useMemo(
    () => [
      {
        icon: <BiUserCircle />,
        title: userId,
        desc: `You are ${roleLabel(uType)}`,
      },
      {
        icon: <BiDiamond />,
        title: Number(dataDes?.data?.balance ?? 0).toFixed(2),
        desc: "Chips",
      },
      {
        icon: <BiGroup />,
        title: `${dataDes?.data?.members ?? 0}`,
        desc: "Members",
      },
      {
        icon: <BiShareAlt />,
        title: `${dataDes?.data?.myShare ?? 0}`,
        desc: "My Share",
      },
      {
        icon: <BiBarChartAlt2 />,
        title: `${dataDes?.data?.companyShare ?? 0}%`,
        desc: "Company Share",
      },
      {
        icon: <BiBarChartAlt2 />,
        title: `${dataDes?.data?.matchCommission ?? 0}%`,
        desc: "Match Comm.",
      },
      {
        icon: <BiBarChartAlt2 />,
        title: `${dataDes?.data?.sessionCommission ?? 0}%`,
        desc: "Session Comm.",
      },
      {
        icon: <BiInfoCircle />,
        title: "Rules",
        desc: "View rules",
        onClick: () => nav("/rules"),
      },
    ],
    [dataDes, userId, uType, nav]
  );

  return (
    <div className="dash-page">
      <AdminDashboardTop />

      <section className="dash_casino_section">
        <div className="dash_casino_header">
          <div className="dash_casino_title">Casino</div>
          <button
            type="button"
            className="dash_casino_link"
            onClick={() => nav("/inplay-casino")}>
            View All
          </button>
        </div>
        <div className="dash_casino_grid">
          {(casinoList?.data || []).slice(0, 12).map((item, index) => (
            <button
              key={item?.tableId || index}
              type="button"
              className="dash_casino_card"
              onClick={() => nav(`/casino/${item?.tableId}`)}>
              <div className="dash_casino_card_img">
                <img
                  loading="lazy"
                  src={resolveCasinoImage(item?.name, index)}
                  alt={item?.name || "Casino"}
                />
              </div>
              <div className="dash_casino_card_title">{item?.name}</div>
            </button>
          ))}
        </div>
      </section>

      <section className="dash-section">
        <h2 className="dash-section__title">Quick actions</h2>
        <div className="dash-tile-grid">
          {actionTiles.map((t) => (
            <DashTile key={t.key} icon={t.icon} label={t.label} onClick={t.onClick} />
          ))}
        </div>
      </section>

      <section className="dash-section">
        <h2 className="dash-section__title">Account</h2>
        <div className="dash-stat-grid">
          {stats.map((s) => (
            <DashStat
              key={`${s.title}-${s.desc}`}
              icon={s.icon}
              title={s.title}
              desc={s.desc}
              onClick={s.onClick}
            />
          ))}
        </div>
      </section>

      <ActiveMatch />

      <LadgerDetails setOpenModals={setOpenModals} openModal={openModal} />
      <CashTransanction
        setOpenModals={setOpenModalsReport}
        openModal={openModalReport}
      />
      <SettingModals setOpenModals={setSetting} openModal={openSetting} />
      <MasterDetails setOpenModals={setOpenDashBoard} openModal={openDashBoard} />
      <SportModal setOpenModals={setSportModals} openModal={openSportModals} />
    </div>
  );
};

export default Dashboard;
